export function QMissingRef(key1, key2, key3) {
  this.fKey1 = key1;
  this.fKey2 = key2;
  this.fKey3 = key3;
}
